import React from "react";
import PropTypes from "prop-types";

const CandyBar = (props) => {
  const {
    x: oX,
    y: oY,
    width: oWidth,
    height: oHeight,
    fill,
    value,
    setTooltipContent,
  } = props;

  const x = oX;
  const y = oHeight < 0 ? oY + oHeight : oY;
  const width = oWidth;
  const height = Math.abs(oHeight);

  return (
    <rect
      fill={fill}
      mask="url(#mask-stripe)"
      x={x}
      y={y}
      width={width}
      height={height}
      onMouseMove={() => {
        setTooltipContent(value);
        console.log("ref area mousemove!");
      }}
      onMouseLeave={() => {
        setTooltipContent("");
      }}
    />
  );
};

CandyBar.defaultProps = {
  x: null,
  y: null,
  width: null,
  height: null,
  fill: null,
};

CandyBar.propTypes = {
  x: PropTypes.number,
  y: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
  setTooltipContent: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default CandyBar;
